import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalHelper } from '../Common/global.service';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PublicService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }  
  GetSchoolSiteMap():Observable<any>{     
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
   return this.httpclient.post<any>(this.globalHelper.ApiUrl+'CMS/GetSchoolSiteMap',{headers:reqHeader}).pipe(
    retry(1),
    catchError(this.handleError)
  );
  }
  GetSchoolSlider():Observable<any>{   
   var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
   return this.httpclient.post<any>(this.globalHelper.ApiUrl+'CMS/GetSchoolSlider',{headers:reqHeader}).pipe(
    retry(1),
    catchError(this.handleError)
  );
  }

  GetSchoolWebsite():Observable<any>{     
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'CMS/GetSchoolWebsite',{headers:reqHeader}).pipe(
    retry(1),
    catchError(this.handleError)
  );
  }

  GetSchoolAccount():Observable<any>{     
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
   return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Public/GetSchoolAccount',{headers:reqHeader}).pipe(
    retry(1),
    catchError(this.handleError)
  );
  }

  GetLookupsList(lookupname:any,prm:any):Observable<any>{     
    let Parameter='LookupName=' +lookupname  + '&parameter=' +prm; 
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
   return this.httpclient.post<any>(this.globalHelper.ApiUrl+'PublicLookup/GetLookupsList?'+encodeURI(Parameter),{headers:reqHeader}).pipe(
    retry(1),
    catchError(this.handleError)
  );
  }

  SaveApplication(data,DocsList): Observable<any> {

    let formData = new FormData();
    for (var i = 0; i < DocsList.length ; i++) {
      if (DocsList[i])
          formData.append("docsFile" + i, DocsList[i].FileUpload);
     }
    formData.append("DocsList", JSON.stringify(DocsList));
    formData.append("objEnquiry", data);
   
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Public/SaveApplication', formData);
  }

  GetApplicationStatusByRegNo(DOB:any,RegistrationNumber:any):Observable<any>{     
    let Parameter='DOB=' +DOB  + '&RegistrationNumber=' +RegistrationNumber; 
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
   return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Public/GetApplicationStatusByRegNo?'+encodeURI(Parameter),{headers:reqHeader}).pipe(
    retry(1),
    catchError(this.handleError)
  );
  }

  GetApplicationPrint(data:any):Observable<any>{     
    let Parameter='StudentID=' +data ; 
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Public/GetApplicationPrint?'+encodeURI(Parameter),{headers:reqHeader}).pipe(
    retry(1),
    catchError(this.handleError)
  );
  }

  GetApplicationDocument(data:any):Observable<any>{     
    let Parameter='StudentID=' +data ; 
    var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
   return this.httpclient.post<any>(this.globalHelper.ApiUrl+'Public/GetApplicationDocument?'+encodeURI(Parameter),{headers:reqHeader}).pipe(
    retry(1),
    catchError(this.handleError)
  );
  }
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
        // client-side error
        errorMessage = `Error: ${error.error.message}`;
    } else {
        // server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}
